// extracted by mini-css-extract-plugin
module.exports = {"header":"SettingModal_header__2LEIE","filters":"SettingModal_filters__2xO91","divider":"SettingModal_divider__2CZ6c","deleteBtn":"SettingModal_deleteBtn__2Sr_I"};